import { Stack } from "@mui/material";
import { Outlet, useLocation } from "react-router-dom";
import ProtectedRoute from "../../routing/ProtectedRoute";
import { ReactNode } from "react";
import ErrorBoundary from "../../common/ErrorBoundary";

const TeacherLayout = ({ children }: { children?: ReactNode }) => {
  const { pathname } = useLocation();

  return (
    <ProtectedRoute>
      <Stack p={3}>
        <ErrorBoundary resetKey={pathname}>
          {children}
          <Outlet />
        </ErrorBoundary>
      </Stack>
    </ProtectedRoute>
  );
};

export default TeacherLayout;
